package com.anjuros.website.templates.template10.sections

import org.jetbrains.compose.web.css.Position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.modifiers.position
import org.w3c.dom.events.EventListener
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.shared.AnjurosVideo
import com.anjuros.website.templates.template10.components.Template10Header
import com.anjuros.website.templates.template10.components.Template10InkCircle
import com.anjuros.website.templates.template10.components.Template10Seal
import com.anjuros.website.templates.template10.components.template10BodyFont
import com.anjuros.website.templates.template10.components.template10HeadingFont
import com.anjuros.website.templates.template10.modules.Template10Section
import com.anjuros.website.templates.template10.modules.Template10Theme
import com.anjuros.website.templates.template10.modules.Template10Venue
import com.anjuros.website.templates.template10.modules.getColor
import com.anjuros.website.templates.template10.styles.Template10HeroStyle
import com.anjuros.website.templates.template10.styles.Template10InkCircleStyle
import com.anjuros.website.templates.template10.styles.Template10MottoStyle
import com.anjuros.website.templates.template10.styles.Template10TaglineStyle
import com.anjuros.website.templates.template10.styles.Template10VenueTileStyle
import com.anjuros.website.templates.template10.styles.Template10WideContainerStyle
import com.anjuros.website.templates.template10.styles.template10Vertical
import com.anjuros.website.templates.template10.util.ResKey
import com.anjuros.website.templates.template10.util.Template10Constants
import com.anjuros.website.templates.template10.util.Template10Glyphs
import com.anjuros.website.templates.template10.util.Template10Res
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Source
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Video
import org.w3c.dom.HTMLVideoElement

@Composable
fun Template10MainSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    onMenuClicked: () -> Unit = {}
) {

    Box(
        modifier = modifier
            .then(Template10HeroStyle.toModifier())
            .id("home")
            .fillMaxWidth()
            .backgroundColor(Template10Theme.InkDeep.rgb)
            .overflow(Overflow.Hidden)
    ) {
        // background video
        Template10HeroVideo { }

        // ink overlay so the white text always reads well
        Box(
            modifier = Modifier
                .fillMaxSize()
                .position(Position.Relative)
                .zIndex(1)
                .styleModifier {
                    property(
                        "background",
                        "radial-gradient(ellipse at 50% 45%, rgba(58,54,49,0.55) 0%, rgba(22,21,19,0.88) 70%)"
                    )
                }
        )

        // side labels (desktop)
        P(
            attrs = Modifier
                .displayIfAtLeast(Breakpoint.LG)
                .align(Alignment.CenterStart)
                .position(Position.Relative)
                .zIndex(2)
                .margin(left = 40.px, top = 0.px, bottom = 0.px, right = 0.px)
                .template10Vertical()
                .template10BodyFont()
                .fontSize(12.px)
                .fontWeight(FontWeight.Bold)
                .letterSpacing(0.4.em)
                .color(Template10Theme.Stone.rgb)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE10_HERO_BADGE1))
        }
        Column(
            modifier = Modifier
                .displayIfAtLeast(Breakpoint.LG)
                .align(Alignment.TopEnd)
                .position(Position.Relative)
                .zIndex(2)
                .margin(top = 140.px, right = 40.px)
                .gap(20.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Span(
                attrs = Modifier
                    .template10Vertical()
                    .template10HeadingFont()
                    .fontSize(30.px)
                    .fontWeight(FontWeight.Bold)
                    .letterSpacing(0.3.em)
                    .color(Template10Theme.Paper.rgb)
                    .toAttrs()
            ) {
                Text(Template10Glyphs.HERO_SIDE)
            }
            Template10Seal(glyph = Template10Glyphs.QI, size = 40, fontSize = 18)
        }

        // header + centre + venue strip
        Column(
            modifier = Modifier
                .fillMaxSize()
                .position(Position.Relative)
                .zIndex(2),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Template10Header(onMenuClicked = onMenuClicked)
            Template10HeroCentre()
            Template10VenueStrip()
        }

    }
}

@Composable
private fun Template10HeroVideo(onVideo: (HTMLVideoElement?) -> Unit) {
    var videoRef by remember { mutableStateOf<HTMLVideoElement?>(null) }
    var visible by remember { mutableStateOf(false) }

    AnjurosVideo(
        modifier = Modifier
            .fillMaxSize()
            .objectFit(ObjectFit.Cover)
    ) {
        // No poster: the hero starts as plain ink colour and the video fades in
        // only once real frames are playing, so there is no flash/flicker.
        Video(
            attrs = Modifier
                .fillMaxSize()
                .objectFit(ObjectFit.Cover)
                .backgroundColor(Template10Theme.InkDeep.rgb)
                .position(Position.Relative)
                .zIndex(0)
                .opacity(if (visible) 1f else 0f)
                .styleModifier {
                    property("transition", "opacity 1.6s cubic-bezier(0.4, 0, 0.2, 1)")
                }
                .toAttrs {
                    attr("playsinline", "")
                    attr("muted", "")
                    attr("autoplay", "true")
                    attr("loop", "true")
                    attr("preload", "auto")
                    ref {
                        videoRef = it
                        onVideo(it)
                        onDispose {
                            it.pause()
                            it.src = ""
                            videoRef = null
                            onVideo(null)
                        }
                    }
                }
        ) {
            Source(
                attrs = {
                    attr("src", Template10Res.Image.hero_video)
                    attr("type", "video/mp4")
                }
            )
        }
    }

    DisposableEffect(videoRef) {
        val video = videoRef
        // show the video only after the first frames have actually been painted
        val onFrames = EventListener {
            if (video != null && video.currentTime > 0.05) visible = true
        }
        video?.addEventListener("timeupdate", onFrames)
        onDispose {
            video?.removeEventListener("timeupdate", onFrames)
        }
    }

    LaunchedEffect(videoRef) {
        videoRef?.let { video ->
            video.muted = true
            video.autoplay = true
            video.loop = true
            var error = false
            var tries = 0
            while (!error && video.paused && tries < 25) {
                video.play().catch { error = true }
                tries++
                delay(200)
            }
            // autoplay blocked (e.g. low-power mode): fade in the still first frame instead
            if (video.paused && video.readyState >= 2) {
                visible = true
            }
        }
    }
}

@Composable
private fun Template10HeroCentre() {
    var visible by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        delay(200)
        visible = true
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(leftRight = 24.px)
            .gap(28.px)
            .opacity(if (visible) 1f else 0f)
            .translateY(if (visible) 0.px else 24.px)
            .styleModifier { property("transition", "opacity 1.2s ease, translate 1.2s ease") },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Box(
            modifier = Template10InkCircleStyle.toModifier(),
            contentAlignment = Alignment.Center
        ) {
            Template10InkCircle()
            Span(
                attrs = Template10MottoStyle.toModifier()
                    .template10Vertical()
                    .template10HeadingFont()
                    .fontWeight(FontWeight.ExtraBold)
                    .letterSpacing(0.18.em)
                    .color(Template10Theme.Paper.rgb)
                    .toAttrs()
            ) {
                Text(Template10Glyphs.MOTTO)
            }
        }

        Column(
            modifier = Modifier.gap(10.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            P(
                attrs = Template10TaglineStyle.toModifier()
                    .margin(0.px)
                    .template10HeadingFont()
                    .fontWeight(FontWeight.Medium)
                    .fontStyle(FontStyle.Italic)
                    .textAlign(TextAlign.Center)
                    .color(Template10Theme.Paper.rgb)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE10_HERO_TITLE))
            }
            P(
                attrs = Modifier
                    .margin(0.px)
                    .template10BodyFont()
                    .fontSize(13.px)
                    .fontWeight(FontWeight.Bold)
                    .letterSpacing(0.3.em)
                    .textTransform(TextTransform.Uppercase)
                    .textAlign(TextAlign.Center)
                    .color(Template10Theme.Stone.rgb)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE10_HERO_SUBTITLE))
            }
        }
    }
}

/** The 3 venues + "book a class" tile along the bottom of the hero. */
@Composable
private fun Template10VenueStrip() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier { property("border-top", "1px solid rgba(244,241,234,0.22)") },
        contentAlignment = Alignment.Center
    ) {
        SimpleGrid(
            numColumns = numColumns(base = 2, lg = 4),
            modifier = Template10WideContainerStyle.toModifier()
        ) {
            Template10Venue.entries.forEach { venue ->
                Link(
                    modifier = Template10VenueTileStyle.toModifier()
                        .textDecorationLine(TextDecorationLine.None)
                        .styleModifier { property("border-right", "1px solid rgba(244,241,234,0.22)") },
                    path = Template10Section.Timetable.path
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(topBottom = 22.px, leftRight = 20.px)
                            .gap(2.px)
                    ) {
                        Span(
                            attrs = Modifier
                                .template10BodyFont()
                                .fontSize(12.px)
                                .fontWeight(FontWeight.Bold)
                                .letterSpacing(0.2.em)
                                .textTransform(TextTransform.Uppercase)
                                .color(Template10Theme.Coral.rgb)
                                .toAttrs()
                        ) {
                            Text("${venue.number} · ")
                            AnjurosText(venue.city)
                        }
                        Span(
                            attrs = Modifier
                                .template10HeadingFont()
                                .fontSize(19.px)
                                .fontWeight(FontWeight.Bold)
                                .color(Template10Theme.Paper.rgb)
                                .toAttrs()
                        ) {
                            Text(LocalText(venue.summary))
                        }
                    }
                }
            }

            Link(
                modifier = Modifier
                    .textDecorationLine(TextDecorationLine.None)
                    .backgroundColor(Template10Theme.Primary.getColor()),
                path = Template10Section.Contact.path
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(topBottom = 22.px, leftRight = 20.px),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Column(modifier = Modifier.gap(2.px)) {
                        Span(
                            attrs = Modifier
                                .template10BodyFont()
                                .fontSize(12.px)
                                .fontWeight(FontWeight.Bold)
                                .letterSpacing(0.2.em)
                                .color(Colors.White)
                                .toAttrs()
                        ) {
                            Text(LocalText(ResKey.TEMPLATE10_BOOK_CLASS))
                        }
                        Span(
                            attrs = Modifier
                                .template10HeadingFont()
                                .fontSize(19.px)
                                .fontWeight(FontWeight.Bold)
                                .color(Colors.White)
                                .toAttrs()
                        ) {
                            AnjurosText(
                                Template10Constants.CLASS_PRICE,
                                com.anjuros.website.components.language.ResKey.PLACEHOLDER_SERVICE_PRICE
                            )
                            Text(" " + LocalText(ResKey.TEMPLATE10_PER_CLASS))
                        }
                    }
                    Template10ArrowIcon(color = "#FFFFFF")
                }
            }
        }
    }
}

@Composable
fun Template10ArrowIcon(color: String, size: Int = 22) {
    Svg(
        attrs = Modifier.size(size.px).toAttrs {
            attr("viewBox", "0 0 24 24")
            attr("fill", "none")
            attr("stroke", color)
            attr("stroke-width", "2")
            attr("stroke-linecap", "round")
            attr("stroke-linejoin", "round")
            attr("aria-hidden", "true")
        }
    ) {
        Path(attrs = { attr("d", "M5 12h14M13 6l6 6-6 6") })
    }
}
